package strings

import io.github.skeptick.libres.strings.PluralForms
import io.github.skeptick.libres.strings.getCurrentLanguageCode
import kotlin.String
import kotlin.collections.Map

public object ResStrings {
  private val baseLocale: StringsEn = StringsEn

  private val locales: Map<String, Strings> = mapOf("pt" to StringsPt, "en" to StringsEn)

  public val locale: String
    get() = locales[getCurrentLanguageCode()]?.locale ?: baseLocale.locale

  public val header_menu_home: String
    get() = locales[getCurrentLanguageCode()]?.header_menu_home ?: baseLocale.header_menu_home

  public val header_menu_about: String
    get() = locales[getCurrentLanguageCode()]?.header_menu_about ?: baseLocale.header_menu_about

  public val header_menu_download: String
    get() = locales[getCurrentLanguageCode()]?.header_menu_download ?:
        baseLocale.header_menu_download

  public val header_menu_contact: String
    get() = locales[getCurrentLanguageCode()]?.header_menu_contact ?: baseLocale.header_menu_contact

  public val header_toggle_color_mode: String
    get() = locales[getCurrentLanguageCode()]?.header_toggle_color_mode ?:
        baseLocale.header_toggle_color_mode

  public val hero_title: String
    get() = locales[getCurrentLanguageCode()]?.hero_title ?: baseLocale.hero_title

  public val hero_description: String
    get() = locales[getCurrentLanguageCode()]?.hero_description ?: baseLocale.hero_description

  public val about_title: String
    get() = locales[getCurrentLanguageCode()]?.about_title ?: baseLocale.about_title

  public val about_description_1: String
    get() = locales[getCurrentLanguageCode()]?.about_description_1 ?: baseLocale.about_description_1

  public val about_description_2: String
    get() = locales[getCurrentLanguageCode()]?.about_description_2 ?: baseLocale.about_description_2

  public val download_title: String
    get() = locales[getCurrentLanguageCode()]?.download_title ?: baseLocale.download_title

  public val download_description: String
    get() = locales[getCurrentLanguageCode()]?.download_description ?:
        baseLocale.download_description

  public val download_google_play: String
    get() = locales[getCurrentLanguageCode()]?.download_google_play ?:
        baseLocale.download_google_play

  public val download_app_store: String
    get() = locales[getCurrentLanguageCode()]?.download_app_store ?: baseLocale.download_app_store

  public val contact_title: String
    get() = locales[getCurrentLanguageCode()]?.contact_title ?: baseLocale.contact_title

  public val contact_description: String
    get() = locales[getCurrentLanguageCode()]?.contact_description ?: baseLocale.contact_description

  public val terms_of_use: String
    get() = locales[getCurrentLanguageCode()]?.terms_of_use ?: baseLocale.terms_of_use

  public val privacy_policy: String
    get() = locales[getCurrentLanguageCode()]?.privacy_policy ?: baseLocale.privacy_policy

  public val copyright: String
    get() = locales[getCurrentLanguageCode()]?.copyright ?: baseLocale.copyright

  public val terms_screen_title: String
    get() = locales[getCurrentLanguageCode()]?.terms_screen_title ?: baseLocale.terms_screen_title

  public val terms_screen_description: String
    get() = locales[getCurrentLanguageCode()]?.terms_screen_description ?:
        baseLocale.terms_screen_description

  public val terms_screen_item_1: String
    get() = locales[getCurrentLanguageCode()]?.terms_screen_item_1 ?: baseLocale.terms_screen_item_1

  public val terms_screen_item_1_1_text: String
    get() = locales[getCurrentLanguageCode()]?.terms_screen_item_1_1_text ?:
        baseLocale.terms_screen_item_1_1_text

  public val terms_screen_item_1_2_text: String
    get() = locales[getCurrentLanguageCode()]?.terms_screen_item_1_2_text ?:
        baseLocale.terms_screen_item_1_2_text

  public val terms_screen_item_1_3_text: String
    get() = locales[getCurrentLanguageCode()]?.terms_screen_item_1_3_text ?:
        baseLocale.terms_screen_item_1_3_text

  public val terms_screen_item_2: String
    get() = locales[getCurrentLanguageCode()]?.terms_screen_item_2 ?: baseLocale.terms_screen_item_2

  public val terms_screen_item_2_1_text: String
    get() = locales[getCurrentLanguageCode()]?.terms_screen_item_2_1_text ?:
        baseLocale.terms_screen_item_2_1_text

  public val terms_screen_item_3: String
    get() = locales[getCurrentLanguageCode()]?.terms_screen_item_3 ?: baseLocale.terms_screen_item_3

  public val terms_screen_item_3_1_text: String
    get() = locales[getCurrentLanguageCode()]?.terms_screen_item_3_1_text ?:
        baseLocale.terms_screen_item_3_1_text

  public val terms_screen_item_4: String
    get() = locales[getCurrentLanguageCode()]?.terms_screen_item_4 ?: baseLocale.terms_screen_item_4

  public val terms_screen_item_4_1_text: String
    get() = locales[getCurrentLanguageCode()]?.terms_screen_item_4_1_text ?:
        baseLocale.terms_screen_item_4_1_text

  public val terms_screen_item_5: String
    get() = locales[getCurrentLanguageCode()]?.terms_screen_item_5 ?: baseLocale.terms_screen_item_5

  public val terms_screen_item_5_1_text: String
    get() = locales[getCurrentLanguageCode()]?.terms_screen_item_5_1_text ?:
        baseLocale.terms_screen_item_5_1_text

  public val terms_screen_item_5_2_text: String
    get() = locales[getCurrentLanguageCode()]?.terms_screen_item_5_2_text ?:
        baseLocale.terms_screen_item_5_2_text

  public val terms_screen_item_5_3_text: String
    get() = locales[getCurrentLanguageCode()]?.terms_screen_item_5_3_text ?:
        baseLocale.terms_screen_item_5_3_text

  public val terms_screen_item_5_4_text: String
    get() = locales[getCurrentLanguageCode()]?.terms_screen_item_5_4_text ?:
        baseLocale.terms_screen_item_5_4_text

  public val terms_screen_item_6: String
    get() = locales[getCurrentLanguageCode()]?.terms_screen_item_6 ?: baseLocale.terms_screen_item_6

  public val terms_screen_item_6_1_text: String
    get() = locales[getCurrentLanguageCode()]?.terms_screen_item_6_1_text ?:
        baseLocale.terms_screen_item_6_1_text

  public val terms_screen_item_7: String
    get() = locales[getCurrentLanguageCode()]?.terms_screen_item_7 ?: baseLocale.terms_screen_item_7

  public val terms_screen_item_7_1_text: String
    get() = locales[getCurrentLanguageCode()]?.terms_screen_item_7_1_text ?:
        baseLocale.terms_screen_item_7_1_text

  public val terms_screen_item_8: String
    get() = locales[getCurrentLanguageCode()]?.terms_screen_item_8 ?: baseLocale.terms_screen_item_8

  public val terms_screen_item_8_1_text: String
    get() = locales[getCurrentLanguageCode()]?.terms_screen_item_8_1_text ?:
        baseLocale.terms_screen_item_8_1_text

  public val terms_screen_item_9: String
    get() = locales[getCurrentLanguageCode()]?.terms_screen_item_9 ?: baseLocale.terms_screen_item_9

  public val terms_screen_item_9_1_text: String
    get() = locales[getCurrentLanguageCode()]?.terms_screen_item_9_1_text ?:
        baseLocale.terms_screen_item_9_1_text

  public val privacy_screen_title: String
    get() = locales[getCurrentLanguageCode()]?.privacy_screen_title ?:
        baseLocale.privacy_screen_title

  public val privacy_screen_description: String
    get() = locales[getCurrentLanguageCode()]?.privacy_screen_description ?:
        baseLocale.privacy_screen_description

  public val privacy_screen_item_1: String
    get() = locales[getCurrentLanguageCode()]?.privacy_screen_item_1 ?:
        baseLocale.privacy_screen_item_1

  public val privacy_screen_item_1_1_text: String
    get() = locales[getCurrentLanguageCode()]?.privacy_screen_item_1_1_text ?:
        baseLocale.privacy_screen_item_1_1_text

  public val privacy_screen_item_1_2_text: String
    get() = locales[getCurrentLanguageCode()]?.privacy_screen_item_1_2_text ?:
        baseLocale.privacy_screen_item_1_2_text

  public val privacy_screen_item_1_3_text: String
    get() = locales[getCurrentLanguageCode()]?.privacy_screen_item_1_3_text ?:
        baseLocale.privacy_screen_item_1_3_text

  public val privacy_screen_item_2: String
    get() = locales[getCurrentLanguageCode()]?.privacy_screen_item_2 ?:
        baseLocale.privacy_screen_item_2

  public val privacy_screen_item_2_1_text: String
    get() = locales[getCurrentLanguageCode()]?.privacy_screen_item_2_1_text ?:
        baseLocale.privacy_screen_item_2_1_text

  public val privacy_screen_item_2_2_text: String
    get() = locales[getCurrentLanguageCode()]?.privacy_screen_item_2_2_text ?:
        baseLocale.privacy_screen_item_2_2_text

  public val privacy_screen_item_2_3_text: String
    get() = locales[getCurrentLanguageCode()]?.privacy_screen_item_2_3_text ?:
        baseLocale.privacy_screen_item_2_3_text

  public val privacy_screen_item_3: String
    get() = locales[getCurrentLanguageCode()]?.privacy_screen_item_3 ?:
        baseLocale.privacy_screen_item_3

  public val privacy_screen_item_3_1_text: String
    get() = locales[getCurrentLanguageCode()]?.privacy_screen_item_3_1_text ?:
        baseLocale.privacy_screen_item_3_1_text

  public val privacy_screen_item_4: String
    get() = locales[getCurrentLanguageCode()]?.privacy_screen_item_4 ?:
        baseLocale.privacy_screen_item_4

  public val privacy_screen_item_4_1_text: String
    get() = locales[getCurrentLanguageCode()]?.privacy_screen_item_4_1_text ?:
        baseLocale.privacy_screen_item_4_1_text

  public val privacy_screen_item_5: String
    get() = locales[getCurrentLanguageCode()]?.privacy_screen_item_5 ?:
        baseLocale.privacy_screen_item_5

  public val privacy_screen_item_5_1_text: String
    get() = locales[getCurrentLanguageCode()]?.privacy_screen_item_5_1_text ?:
        baseLocale.privacy_screen_item_5_1_text
}
